import { jsxs, jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
const DrawerTitle = ({
  classes,
  className,
  icon,
  title,
  subTitle,
  backButton,
  closeButton,
  size = "md"
}) => {
  const { themeClasses } = useThemePresetClasses("DrawerTitle", classes, className, {
    modifier: size
  });
  return /* @__PURE__ */ jsxs("div", { className: cn("relative", themeClasses == null ? void 0 : themeClasses.root), children: [
    backButton && /* @__PURE__ */ jsx("span", { className: cn("absolute", themeClasses == null ? void 0 : themeClasses.backButtonWrapper), children: backButton }),
    closeButton && /* @__PURE__ */ jsx("span", { className: cn("absolute", themeClasses == null ? void 0 : themeClasses.closeButtonWrapper), children: closeButton }),
    /* @__PURE__ */ jsxs("div", { className: cn("flex items-center justify-center space-x-3"), children: [
      icon,
      /* @__PURE__ */ jsx("span", { className: cn("inline-block", themeClasses == null ? void 0 : themeClasses.title), children: title })
    ] }),
    subTitle && /* @__PURE__ */ jsx("p", { className: cn(themeClasses == null ? void 0 : themeClasses.subTitle), children: subTitle })
  ] });
};
const DrawerTitle$1 = DrawerTitle;
export {
  DrawerTitle$1 as default
};
